//react...
import React from "react";

//styles...
import "./Slider.styles.css";

//react-bootstarp...
import { Carousel, CarouselItem } from "react-bootstrap";

//data...
import APP_DATA from "../../APP_DATA";

const Slider = () => {
  const slider = APP_DATA.slider;
  return (
    <div>
      <Carousel>
        {slider.map((item) => {
          return (
            <CarouselItem key={item.id}>
              <img className="d-block w-100 slider-item" src={item.imageUrl} alt="Slider" />
            </CarouselItem>
          );
        })}
      </Carousel>
    </div>
  );
};

export default Slider;
